const colors = {
    0: '#2D3032',
    1: '#702DE1',
    2: '#74A8E3',
    3: '#CF588A',
    4: '#469787',
    5: '#D8D666',
    6: '#F89420',
    7: '#C58FB2',
    8: '#6BBA53',
    9: '#AA2380',
    10: '#33B8A0',
    11: '#2D41FA',
    12: '#9161EF',
    13: '#D74737',
    14: '#DB966F',
    15: '#6D789A',
    16: '#4B69FF',
    17: '#e12d57',
    18: '#839746',
};

export function getColor(colorId: any) {
    return colors[colorId as keyof typeof colors];
}

// Gray is RESERVED for levels 0–9 only. It is intentionally low-saturation so
// it can never be confused with any higher-tier colour.
export const LEVEL_GRAY = '#7c8696';

// Level → colour, consistent across the whole project.
// • 0–9 → always gray (LEVEL_GRAY), and nothing else uses gray.
// • 10+ → vivid, high-saturation colours spread by the golden angle (~137.5°)
//   so every tier is distinct from its neighbours and none looks gray.
// • 500+ → gold cap.
export function getLevelColor(level: number): string {
    if (!Number.isFinite(level) || level < 10) return LEVEL_GRAY;

    const tier = Math.floor(level / 10);
    if (tier >= 50) return '#FFD700'; // gold cap for 500+

    const idx = tier - 1; // 0 → 10–19, 1 → 20–29, …
    const hue = Math.round((18 + idx * 137.508) % 360);
    // Saturation stays high (80–96%) so a tier is never washed-out / gray-ish.
    const sat = 80 + ((idx * 11) % 16);
    const light = 56 + ((idx * 5) % 12); // 56–67%
    return `hsl(${hue} ${sat}% ${light}%)`;
}

// Experience → colour. Delegates to getLevelColor so every level-coloured
// element in the project shares the same scheme (0–9 gray, etc.).
export function getUserColor(experience: number) {
    return getLevelColor(Math.floor((experience ?? 0) / 100));
}
